import { LocationUtilities, SiteUtilities } from '../utils';
import { getPayload } from '../demo-form-payload';
const product = jQuery('body').attr('data-product-name');

/*
* animateFormWrapper to used to design a form
* with thank you message. When users click submit button
* then thank you message shows in light box.
*/
var animateFormWrapper = function (classname, form) {
  const email = $(form).find('input[name^="email"]').val();
  const emailHash = SiteUtilities.getShaHash(email);
  $('.' + classname).find('.button').addClass('button--loading').attr('disabled', 'disabled');

  // Hit GA with tracking info for this form submission
  try {
    var trackers = ga.getAll();
    var isFworks = true;

    // if there are GA properties other than the Fworks
    // property, isFworks is false - i.e. this submission
    // is happening in a product-level page
    for (var t = 0; t < trackers.length; t++) {
      if (trackers[t].get('trackingId') !== 'UA-100469290-1') {
        isFworks = false;
      }
    }

    // get the location to scope the conversion to the page
    // where the submission is happening
    var locationPrefix = window.location.pathname ? window.location.pathname : '';
    const product = $('body').attr('data-product-name');
    let virtualHitUrl;
    // Add /thank-you for freshdesk and freshservice alone because trailing slashes are removed
    if (product === 'fdesk' || product === 'fservice') {
      virtualHitUrl = `${locationPrefix}/thank-you?ehash=${emailHash}`;
    } else {
      virtualHitUrl = `${locationPrefix}thank-you?ehash=${emailHash}`;
    }

    var sendHit = function (trackerName) {
      ga(trackerName + '.set', {
        page: virtualHitUrl,
        title: 'Form at ' + locationPrefix + ' submitted'
      });
      ga(trackerName + '.send', 'pageview', {
        page: virtualHitUrl,
        title: 'Form at ' + locationPrefix + ' submitted'
      });
    };

    for (t = 0; t < trackers.length; t++) {
      if (!isFworks && trackers[t].get('trackingId') !== 'UA-100469290-1') {
        // If this is not a www.freshworks.com company-level page
        // post the conversion details to the product's GA property
        // and avoid posting the conversion detail to the Fworks property
        sendHit(trackers[t].get('name'));
      } else if (isFworks && trackers[t].get('trackingId') === 'UA-100469290-1') {
        // if this is a company-level page, post the conversion
        // to the Fworks GA property only
        sendHit(trackers[t].get('name'));
      }
    }
  } catch (e) {
    // Error logging to be done
  }
  if (classname.toLowerCase().includes('webinar')) {
    const geoLocation = LocationUtilities.getGeoLocation();
    // Freshmarketer Data
    const freshmarketerData = {
      freshmarketerObject: {
        first_name: $(form).find('input[name^="first-name"]').val(),
        last_name: $(form).find('input[name^="last-name"]').val(),
        email: email,
        company: $(form).find('input[name^="company"]').val() || '',
        phone: $(form).find('input[name^="phone"]').val(),
        contactable: ($(form).find('input[name="send_promotions"]').is(':checked')),
        custom_field: {
          cf_freshmarketer_list: $(form).find('.fm-list-id').val()
        }
      }
    };
    if (SiteUtilities.GDPRFunctionalCookieDisabled()) {
      freshmarketerData.freshmarketerObject['country'] = geoLocation ? geoLocation.countryName : '';
    } else {
      freshmarketerData.freshmarketerObject['city'] = geoLocation ? geoLocation.cityName : '';
      freshmarketerData.freshmarketerObject['state'] = geoLocation ? geoLocation.regionName : '';
      freshmarketerData.freshmarketerObject['country'] = geoLocation ? geoLocation.countryName : '';
      freshmarketerData.freshmarketerObject['zipcode'] = geoLocation ? geoLocation.zipCode : '';
    }
    try {
      if ($(form).find('input[name^="checkbox"]').val()) {
        freshmarketerData['freshmarketerObject']['custom_field']['cf_smsreminder'] = $(form).find('input[name^="checkbox-sms-remainder"]').is(':checked').toString();
      }
      if ($(form).find('select[name^="query-contact"]').val()) {
        freshmarketerData['freshmarketerObject']['custom_field']['cf_timeslotforwebinar'] = $(form).find('select[name^="query-contact"]').val();
      }
      if ($(form).find('.job-tile-form').val()) {
        freshmarketerData['freshmarketerObject']['custom_field']['cf_title'] = $(form).find('.job-tile-form').val();
      }
    } catch (e) {
      console.error(e);
      SiteUtilities.log(
        'Webinar - Custom Fields Error',
        'error',
        'FW.Submit.animateFormWrapper',
        2,
        e
      );
    }
    SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
    window.ZargetFormAPI = window.ZargetFormAPI || [];
    window.ZargetFormAPI.push('fdesk-proactive-webinar', 'WebinarSuccess');
    window.ZargetFormAPI.push('fworks-chatbot-experience-webinar', 'chatbot-webinarSuccess');
    window.ZargetFormAPI.push('fworks-streamline-helpdesk-webinar', 'streamline-helpdesk-webinarSuccess');
    window.ZargetFormAPI.push('fworks-boost-sales-livechat-webinar', 'boost-sales-livechat-webinarSuccess');
    window.ZargetFormAPI.push('fworks-GDPR-webinar', 'fworks-GDPR-webinar-webinarSuccess');
  }
  setTimeout(function () {
    $('.animate-form-wrapper h3, .animate-form-wrapper h5, .animate-form-wrapper form, .animate-form-wrapper .thank-you-card').addClass('active');
    $('.animate-form-wrapper').animate({
      height: $('.thank-you-card').innerHeight()
    });
  }, 1000);
};

var contactForm = function (classname, form) {
  const fmListId = $(form).find('.fm-list-id').val();
  const firstName = $(form).find('.first-name-form').val();
  const lastName = $(form).find('.last-name-form').val();
  const emailid = $(form).find('.email-form').val();
  const emailHash = SiteUtilities.getShaHash(emailid);
  const geoLocation = LocationUtilities.getGeoLocation();
  const phone = $(form).find('.phone-form').val();
  $('.' + classname).find('.button').addClass('button--loading').attr('disabled', 'disabled');
  setTimeout(function () {
    $('.contact-form-wrapper h3, .contact-form-wrapper form, .contact-form-wrapper .thank-you-card').addClass('active');
  }, 1000);
  window.ZargetFormAPI = window.ZargetFormAPI || [];
  window.ZargetFormAPI.push('zg_form', 'ForestPricingSuccess');
  if (product === 'fmarketer') {
    if (fmListId) {
      const freshmarketerData = {
        freshmarketerObject: {
          first_name: firstName,
          last_name: lastName,
          email: emailid,
          country: geoLocation ? geoLocation.countryName : '',
          phone: phone || '',
          contactable: $(form).find('input[name="send_promotions"]').is(':checked'),
          custom_field: {
            cf_freshmarketer_list: fmListId
          }
        }
      };
      SiteUtilities.freshmarketerPost(freshmarketerData, false, form);
    }
  }

  if (product === 'fworks') {
    const query = $('select[name="query-contact"]').val();
    const virtualHitObject = {
      Support: 'https://www.freshworks.com/contact/support-success',
      Sales: 'https://www.freshworks.com/contact/sales-success',
      'Press and Media': 'https://www.freshworks.com/contact/press-media-success'
    };
    const virtualHitUrl = virtualHitObject[query];
    try {
      var trackers = ga.getAll();
      for (var t = 0; t < trackers.length; t++) {
        if (trackers[t].get('trackingId') === 'UA-100469290-1') {
          var trackerName = trackers[t].get('name');
          ga(trackerName + '.set', {
            page: virtualHitUrl + `?ehash=${emailHash}`,
            title: 'Web - Contact Us Form'
          });
          ga(trackerName + '.send', 'pageview', {
            page: virtualHitUrl + `?ehash=${emailHash}`,
            title: 'Web - Contact Us Form'
          });
          break;
        }
      }
    } catch (e) {
      // Error logging to be done
    }

    if (fmListId) {
      // Freshmarketer Data
      const freshmarketerData = {
        freshmarketerObject: {
          first_name: firstName,
          last_name: lastName,
          country: geoLocation ? geoLocation.countryName : '',
          email: emailid,
          phone: phone || '',
          contactable: $(form).find('input[name="send_promotions"]').is(':checked'),
          custom_field: {
            cf_freshmarketer_list: fmListId,
            cf_fworkstypeofquery: query,
            cf_fworksbugaffectedurl: $(form).find('textarea[name^="message"]').val(),
            cf_recentnote: $(form).find('textarea[name^="message"]').val()
          }
        }
      };
      SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
    }
  }
};

const roiForm = (classname, form) => {
  $(form).find('.button').addClass('button--loading');
  const roiCompanyName = $($(form).find('input[name^="company"]')).val();
  const roiIndustryType = $($(form).find('select[name^="query-industry"]')).val();
  const roiAgents = $($(form).find('input[name^="number-of-agents"]')).val();
  const roiQueries = $($(form).find('input[name^="number-of-queries"]')).val();
  const roiSupportSystem = $($(form).find('select[name^="query-support-system-list"]')).val();

  window.location.href = '/roi-report?it=' + roiIndustryType + '&ag=' + roiAgents + '&qr=' + roiQueries + '&ss=' + roiSupportSystem + '&roicn=' + roiCompanyName;
};

const roiDetailedReportForm = (classname, form) => {
  const getParam = window.location.search.substring(1);
  window.location.href = '/roi-detailed-report?' + getParam;
};

const webinarSubscribeForm = (classname, form) => {
  localStorage.setItem('webinar-subscribed', true);
  var $formSelector = $(form);
  var $modalWrapper = $formSelector.parents('.modal-body').find('> .form-wrapper');
  $formSelector.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const emailid = $formSelector.find('input[name^="email"]').val();
  const emailHash = SiteUtilities.getShaHash(emailid);
  const $sendPromotions = $('[name="send_promotions"]');
  const geoLocation = LocationUtilities.getGeoLocation();
  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      email: emailid,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: $sendPromotions.length ? $sendPromotions.is(':checked') : true,
      custom_field: {
        cf_freshmarketer_list: $(form).find('.fm-list-id').val()
      }
    }
  };
  SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
  $formSelector.parent().slideUp(300);
  if ($formSelector.parent('.form-wrapper').length) {
    $formSelector.parent('.form-wrapper').siblings('.signup-terms').hide();
  }
  setTimeout(function () {
    $modalWrapper.find('.modal-content-wrapper').hide();
    $formSelector.parents('.form-single-field-wrapper').find('> .signup-terms').hide();
    $formSelector.parents('.form-single-field-wrapper').find('.forgot-domain-success').slideDown(300);
    if ($formSelector.parent('.form-wrapper').length) {
      $formSelector.parents('.form-wrapper').siblings('.forgot-domain-success').slideDown(300);
    }
  }, 300);
  const dataLink = $(form).find('.data-link.active').val();
  if (dataLink && dataLink !== '') {
    const ehashParam = dataLink.match(/\?./) ? `&ehash=${emailHash}` : `?ehash=${emailHash}`;
    setTimeout(function () {
      window.location = dataLink + ehashParam;
    }, 1500);
  }
};

const unsubscribe = function (className) {
  const $form = $('form.' + className);
  $form.find('.button').on('click', function (e) {
    e.preventDefault();
    $form.find('input:checked').each(function () {
      $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
    });
    setTimeout(function () {
      window.location.href = '/unsubscribe/thank-you';
    }, 1000);
  });
};

var emailOnlySubscription = function (classname, form) {
  const $form = $(form);
  const geoLocation = LocationUtilities.getGeoLocation();
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const email = $form.find('input[name^="email"]').val();
  const emailHash = SiteUtilities.getShaHash(email);
  const $sendPromotions = $('[name="send_promotions"]');
  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      email: email,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: $sendPromotions.length ? $sendPromotions.is(':checked') : true,
      custom_field: {
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      }
    }
  };
  if ($form.attr('data-redirect').length > 0) {
    jQuery.when(
      SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
    ).then(function () {
      window.location.href = $form.attr('data-redirect') + `/?ehash=${emailHash}`;
    });
  } else {
    const $modalElem = $form.find('.modal-id');
    const modalId = $modalElem.length ? '#' + $modalElem.val() : '';
    // Post to Freshmarketer
    SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
    $form.find('.button').removeClass('button--loading').removeAttr('disabled', 'disabled');
    $form.parent('.form-wrapper').siblings('.signup-terms').hide();
    if (modalId.length) {
      setTimeout(function () {
        $(modalId).modal('show');
        $form.find('input[name^="email"]').val('');
      }, 500);
    } else {
      const $formWrapper = $form.closest('.form-wrapper');
      if (!$formWrapper.find('.form-wrapper').length) {
        $formWrapper.slideUp(300);
      } else {
        $formWrapper.find('.form-wrapper').slideUp(300);
      }
      const $successElem = $formWrapper.siblings('.forgot-domain-success');
      setTimeout(function () {
        $successElem.slideDown(300);
        $successElem.addClass('mb-xl');
      }, 300);
    }
  }
};

const gdprSubscriptionToggleForm = (classname, form) => {
  const email = $(form).find('.email-form').val();
  const fmListId = $(form).find('.fm-list-id').val();
  $(form).find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const geoLocation = LocationUtilities.getGeoLocation();
  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      email: email,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: true,
      custom_field: {
        cf_freshmarketer_list: fmListId
      }
    }
  };

  // In the case of gdpr unsubscribe form, add subscription_status field at 0; dont pass contactable field
  const unsubscribe = $(form).attr('data-gdpr-unsubscribe');
  if (unsubscribe === 'true') {
    freshmarketerData.freshmarketerObject['subscription_status'] = 0;
    delete freshmarketerData.freshmarketerObject.contactable;
  }

  SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
  $(form).find('.button').removeClass('button--loading').removeAttr('disabled', 'disabled');
  jQuery('.form-wrapper').slideUp(300);
  setTimeout(function () {
    jQuery('.forgot-domain-success').slideDown(300);
  }, 300);
};

const whitepaperForm = (classname, form) => {
  const emailId = $(form).find('.email-form').val();
  const emailHash = SiteUtilities.getShaHash(emailId);
  const geoLocation = LocationUtilities.getGeoLocation();
  // Post to freshmarketer.
  const $form = $(form);
  // Construct freshmarketer object for api submission only on 200 status code
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: $form.find('.first-name-form').val(),
      last_name: $form.find('.last-name-form').val(),
      email: emailId,
      phone: $form.find('.phone-form').val() || '',
      company: $form.find('.company-form').val(),
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      }
    }
  };
  // Freshmarketer Custom event  data - end
  const $btn = $(form).find('.button');
  const dataProductUrl = $btn.attr('data-url');
  if (!dataProductUrl) {
    SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
    $btn.addClass('button--loading').attr('disabled', 'disabled');
    setTimeout(function () {
      $(form).addClass('inactive');
      const outerHeight = $('.whitepaper-form-wrapper .thank-you-card').addClass('active').outerHeight();
      $(form).animate({
        minHeight: outerHeight
      });
      $('.whitepaper-form-wrapper .thank-you-card').addClass('active');
      $('div.align-center h5').hide();
      $btn.addClass('hide');
    }, 1000);
    window.ZargetFormAPI = window.ZargetFormAPI || [];
    window.ZargetFormAPI.push('fdesk_form', 'success');
  } else {
    $btn.addClass('button--loading').val('Downloading...');
    setTimeout(function () {
      jQuery.when(
        SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
      ).then(function () {
        window.location.href = $btn.data('url') + `?ehash=${emailHash}`;
      });
    }, 1500);
  }
  try {
    var getPageName = window.location.pathname.split('/');
    var trackers = ga.getAll();
    for (var t = 0; t < trackers.length; t++) {
      if (trackers[t].get('trackingId') === 'UA-20651269-1') {
        var trackerName = trackers[t].get('name');
        ga(trackerName + '.set', {
          page: 'https://freshdesk.com/resources/whitepaper/downloaded?whitepaper=' + getPageName[3] + `&ehash=${emailHash}`,
          title: 'Whitepaper Downloaded'
        });
        ga(trackerName + '.send', 'pageview', {
          page: 'https://freshdesk.com/resources/whitepaper/downloaded?whitepaper=' + getPageName[3] + `&ehash=${emailHash}`,
          title: 'Whitepaper Downloaded'
        });
        break;
      }
    }
  } catch (e) {
    // Error logging to be done
  }
};

const jobDescriptionForm = (classname, form) => {
  const geoLocation = LocationUtilities.getGeoLocation();
  const email = $(form).find('input[name^="email"]');
  // Freshmarketer Data
  // Construct freshmarketer object for api submission only on 200 status code
  const freshmarketerData = {
    freshmarketerObject: {
      email: email,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($(form).find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_freshmarketer_list: $(form).find('.fm-list-id').val()
      }
    }
  };
  SiteUtilities.freshmarketerPost(freshmarketerData, true, form);

  setTimeout(function () {
    window.location.href = $(form).attr('data-redirect') + '/';
  }, 2000);
};

const partnerResellerSignupForm = (classname, form) => {
  // Dont remove this.
};

const createSupportTicket = (className, form) => {
  // Dont remove this
};

const affiliateForm = (className, form) => {
  const $form = $(form);
  const email = $form.find('input.email-form').val();
  // ----- Temporarily affiliate signup API was removed
  // $form.find('.button').addClass('button--loading');
  // const affiliateSignupUrl = $form.data('signup-url') || 'https://alfred.freshworks.com/v1/affiliate-signup';
  // const affiliateSignupObject = {
  //   first_name: $form.find('input.first-name-form').val(),
  //   last_name: $form.find('input.last-name-form').val(),
  //   email: email,
  //   country: $form.find('.country-form').val()
  // };

  // const affiliatePost = (affiliateSignupObject) => {
  //   jQuery.ajax({
  //     data: JSON.stringify(affiliateSignupObject),
  //     method: 'POST',
  //     url: affiliateSignupUrl,
  //     contentType: 'application/json',
  //     dataType: 'json',
  //     complete: (response) => {
  //       successfulSubmission();
  //     }
  //   });
  // };

  const successfulSubmission = () => {
    // $form.find('.button').removeClass('button--loading');
    jQuery('.affiliate-signup-section h1').css('display', 'none');
    jQuery('.affiliate-form-wrapper').addClass('psr-LeftOut-animation');
    const geoLocation = LocationUtilities.getGeoLocation();
    setTimeout(() => {
      jQuery('.affiliate-form-wrapper').addClass('hide-sections');
      $form.parents('.affiliate-form-wrapper').siblings('.thank-you-card').addClass('active');
    }, 150);
    try {
      var trackers = ga.getAll();
      for (var t = 0; t < trackers.length; t++) {
        if (trackers[t].get('trackingId') === 'UA-100469290-1') {
          var trackerName = trackers[t].get('name');
          ga(trackerName + '.set', {
            page: `/company/affiliate-partner/affiliate-signup/complete`,
            title: 'Affiliate Signup Complete'
          });
          ga(trackerName + '.send', 'pageview', {
            page: `/company/affiliate-partner/affiliate-signup/complete`,
            title: 'Affiliate Signup Complete'
          });
          break;
        }
      }
    } catch (e) {
      // Error logging to be done
    }
    // Freshmarketer Data
    const freshmarketerData = {
      freshmarketerObject: {
        first_name: $form.find('input.first-name-form').val(),
        last_name: $form.find('input.last-name-form').val(),
        email: email,
        country: geoLocation ? geoLocation.countryName : '',
        contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
        custom_field: {
          cf_freshmarketer_list: $form.find('.fm-list-id').val()
        }
      }
    };
    SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
  };

  // affiliatePost(affiliateSignupObject);
  successfulSubmission();
};

const expressCheckoutForm = (classname, form) => {
  const phoneNumber = $(form).find('input[name^="phone"]').val();
  const unsubscribed = $(form).find('input[name="send_promotions"]').is(':checked');
  const $signupForm = $('#' + classname).siblings('form.fservice-signup-form');
  if (phoneNumber.length > 0) {
    localStorage.setItem('number_given', '----' + phoneNumber);
  }
  if (unsubscribed && !$signupForm.find('input[name="send_promotions"]').is(':checked')) {
    $signupForm.find('input[name="send_promotions"]').click();
  }
  $(form).find('.button').addClass('button--loading').attr('disabled', 'disabled');
  setTimeout(function () {
    $('.animate-form-wrapper h3, .animate-form-wrapper p.modal-sub-text').addClass('active');
  }, 1000);
  // to make sure we dont show the modal everytime click retry on signup form
  localStorage.setItem('expressModalShown', true);
  // if the signup form is present inside a modal box already
  if ($signupForm.attr('data-parent-modal') === 'yes') {
    $('#phone-modal').trigger('expressNumberGiven');
  } else { // if the sign up form is present directly on the page
    setTimeout(function () {
      $('#phone-modal').modal('hide');
    }, 1500);
  }
};

var academyForm = function (className, form) {
  const $form = $(form);
  const signupUrl = $form.data('signup-url') || 'https://agent-hermes.freshdesk.com/fw-academy/users';
  const geoLocation = LocationUtilities.getGeoLocation();
  const sendPromotions = ($form.find('input[name="send_promotions"]').is(':checked'));
  const email = $form.find('input[name^="email"]').val();
  const group = $form.find('.northpass-group-name').val();
  $('.' + className).find('.button').addClass('button--loading').attr('disabled', 'disabled');
  // Construct freshmarketer object.
  const freshmarketerData = {
    freshmarketerObject: {
      email: email,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: sendPromotions,
      custom_field: {
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      }
    }
  };
  SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
  setTimeout(function () {
    $('.academy-form-wrapper form, .academy-form-wrapper .thank-you-card').addClass('active');
  }, 500);

  if (group !== '') {
    var userdata = JSON.stringify({
      data: {
        attributes: {
          people: [{
            email,
            groups: group
          }]
        }
      }
    });

    var settings = {
      async: true,
      crossDomain: true,
      url: signupUrl,
      type: 'POST',
      processData: false,
      data: userdata
    };

    $.ajax(settings)
      .done(function (response) {})
      .fail((jqXHR, textStatus) => {
        SiteUtilities.log(
          'Freshworks academy form',
          'warning',
          'submitHandlers.AcademyForm (ajax call failed)',
          0,
          textStatus
        );
      });
  }
};

const accessSecurityResourcesForm = (classname, form) => {
  const $form = $(form);
  const $btn = $form.find('.button');
  $btn.addClass('button--loading').attr('disabled', 'disabled');
  let resources = {};
  const email = $form.find('input[name^="email"]').val();
  const name = $form.find('input[name^="name"]').val();
  const company = $form.find('input[name^="company"]').val();
  const existingCustomer = $form.find('option:selected').attr('data-value');
  const productName = $form.find('input[name^="productname"]').val();
  const securityResourceUrl = 'https://alfred.freshworks.com/v1/security-resources';

  $form.find('input[name="categories"]').each(function () {
    resources[$(this).val().split(' ').join('_').toLowerCase()] = $(this).is(':checked');
  });
  // to remove extra semicolon
  if (resources.length > 2) {
    resources = resources.slice(0, resources.length - 2);
  }
  // PostData to lighthouse
  const lighthouseData = {
    email: 'customer.asks@freshservice.com',
    requested_for: 'customer.asks@freshservice.com',
    custom_fields: {
      company: company,
      customer_email: email,
      customer_name: name,
      existing_customer: existingCustomer
    }
  };
  if (existingCustomer === 'No' && productName !== '') {
    lighthouseData.custom_fields['product_name'] = productName;
  }
  $.extend(lighthouseData.custom_fields, resources);

  // PostData to micro service
  $.ajax({
    url: securityResourceUrl,
    contentType: 'application/json',
    type: 'POST',
    data: JSON.stringify(lighthouseData),
    success: (response) => {
      if (response.errorType) {
        $btn.removeClass('button--loading').removeAttr('disabled').attr('value', 'Retry');
      } else {
        $btn.removeClass('button--loading').removeAttr('disabled');
        animateFormWrapper(classname);
      }
    },
    error: (xhr, status, err) => {
      $btn.removeClass('button--loading').removeAttr('disabled').attr('value', 'Retry');
    }
  });
};

const bugReportForm = (classname, form) => {
  const firstName = $(form).find('input[name^="first-name"]').val();
  const lastName = $(form).find('input[name^="last-name"]').val();
  const email = $(form).find('input[name^="email"]').val();
  const issueType = $(form).find('input[name^="issue"]').val();
  const bugType = $(form).find('[name^="bug"]').val();
  const urlType = $(form).find('input[name^="url"]').val();
  const domainType = $(form).find('input[name^="domain"]').val();
  const docType = $(form).find('input[name^="doc"]').val();
  const messageType = $(form).find('textarea[name^="message"]').val();
  const geoLocation = LocationUtilities.getGeoLocation();
  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      email: email,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: true,
      custom_field: {
        cf_freshmarketer_list: $(form).find('.fm-list-id').val(),
        cf_fworksbugname: issueType,
        cf_fworksbugproductdomain: domainType,
        cf_fworksbugtype: bugType,
        cf_fworksbugaffectedurl: urlType,
        cf_fworksbuggoogledoc: docType,
        cf_fworksstepstoreproducebug: messageType
      }
    }
  };
  SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
  animateFormWrapper(classname);
};

const getCheckboxValueString = function ($customCheckboxDiv) {
  let checkboxValues = '';
  const $checkboxesArray = $customCheckboxDiv.find('.checkbox-control-group input[name="checkbox"]:checked');
  $checkboxesArray.each((index, element) => {
    const $element = $(element);
    checkboxValues += $element.attr('value') + ', ';
  });
  return checkboxValues.trim().slice(0, -1);
};

const sysadminForm = (className, form) => {
  const $form = $(form);
  $form.find('.button').addClass('button--loading');
  const name = $form.find('.first-name-form').val() + $form.find('.last-name-form').val();
  const sendEmailButtonLabel = $form.attr('data-send-email-button-label');
  const sysadminName = $form.find('.sysadmin-name-form').val();
  const sysadminMessage = $form.find('.sysadmin-message-form').val();
  let $carouselWrapper = $('.greeting-carousel');
  const geoLocation = LocationUtilities.getGeoLocation();
  const $buttonHTML = `
    <div class="button-wrapper pt-md">
      <a href="#" class="button button--solid" data-dynamic-button>${sendEmailButtonLabel}</a>
    </div>
  `;
  const carouselSectionHeading = $form.attr('data-carousel-dynamic-heading');
  // Make changes to the existing carousel.
  $carouselWrapper.find('.greeting-text').text(`Dear ${sysadminName},`);
  $carouselWrapper.find('.message-body').text(sysadminMessage);
  $carouselWrapper.find('.author-name').text(name);
  const $carouselParent = $carouselWrapper.closest('.container');
  // Make a copy of the carousel. The reason we clone is because there are issues with the height transitions when dynamic content is inserted.
  const carouselHTML = $carouselWrapper.prop('outerHTML');
  $carouselWrapper.remove();
  const dynamicHeadingHTML = `
    <div class="l-section-heading align-center" data-section-heading>
      <h2>${carouselSectionHeading}</h2>
    </div>
  `;
  $('[data-section-heading]').remove();
  $carouselParent.append(dynamicHeadingHTML);
  $carouselParent.append(carouselHTML);
  // Initialize the new carousel
  $carouselWrapper = $('.greeting-carousel');
  $carouselWrapper.siblings('.button-wrapper').remove();
  $carouselWrapper.after($buttonHTML);
  $('html, body').animate({
    scrollTop: $('[data-section-heading]').offset().top - $('nav').height()
  }, 1000);
  $form.find('.button').removeClass('button--loading');
  $('[data-dynamic-button]').on('click', (e) => {
    e.preventDefault();
    const $carousels = $carouselWrapper.find('.carousel-item');
    let carouselIndex;
    $carousels.each((index, carousel) => {
      if ($(carousel).hasClass('active')) {
        carouselIndex = index;
      }
    });
    const freshmarketerCustomFields = {
      cf_freshmarketer_list: $form.find('.fm-list-id').val(),
      cf_recentnote: $form.find('.sysadmin-email-form').val(),
      cf_cftextbox: sysadminMessage.trim()
    };
    $form.find('[data-fm-key]').each(function () {
      const $this = $(this);
      let key = $this.data('fm-key');
      if (key) {
        key = key.toLowerCase().trim().replace(' ', '_');
        freshmarketerCustomFields['cf_' + key] = $this.val().trim();
      }
    });
    let eCardIndexFmarketerKey = $form.find('.fm-e-card-index').val();
    if (eCardIndexFmarketerKey) {
      eCardIndexFmarketerKey = eCardIndexFmarketerKey.toLowerCase().replace(' ', '_');
      freshmarketerCustomFields['cf_' + eCardIndexFmarketerKey] = carouselIndex + 1;
    }
    const selectedTemplate = $carouselWrapper.find('.carousel-item.item.active');
    const templateId = $(selectedTemplate).find('.template-id').text();
    freshmarketerCustomFields.cf_fconnectadminemail = templateId || '';
    const freshmarketerData = {
      freshmarketerObject: {
        first_name: $form.find('.first-name-form').val(),
        last_name: $form.find('.last-name-form').val(),
        email: $form.find('.email-form').val(),
        middle_name: sysadminName,
        country: geoLocation ? geoLocation.countryName : '',
        custom_field: freshmarketerCustomFields
      }
    };
    SiteUtilities.freshmarketerPost(freshmarketerData, false, form);
    $('#sysadmin-modal').modal();
  });
};

const buildFreshmarketerObject = (form, geoLocation) => {
  const $form = $(form);
  // const $body = $('body');
  // Hardcoded configuration first.
  const freshmarketerContact = {
    contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
    custom_field: {
      cf_freshmarketer_list: $form.find('.fm-list-id').val()
    }
  };
  if (!SiteUtilities.GDPRFunctionalCookieDisabled()) {
    freshmarketerContact['state'] = geoLocation ? geoLocation.regionName : '';
    freshmarketerContact['city'] = geoLocation ? geoLocation.cityName : '';
    freshmarketerContact['country'] = geoLocation ? geoLocation.countryName : '';
    freshmarketerContact['continent'] = geoLocation ? geoLocation.continentName : '';
    freshmarketerContact['zipcode'] = geoLocation ? geoLocation.zipCode : '';
  } else {
    freshmarketerContact['country'] = geoLocation ? geoLocation.countryName : '';
  }

  // :TODO Custom input elements
  if ($form.find('.first-name-form').length > 0) {
    freshmarketerContact['first_name'] = $form.find('.first-name-form').val();
  }
  if ($form.find('.last-name-form').length > 0) {
    freshmarketerContact['last_name'] = $form.find('.last-name-form').val();
  }
  if ($form.find('.email-form').length > 0) {
    freshmarketerContact['email'] = $form.find('.email-form').val();
  }
  if ($form.find('.company-form').length > 0) {
    freshmarketerContact['company'] = $form.find('.company-form').val();
  }
  if ($form.find('.phone-form').length > 0) {
    freshmarketerContact['phone'] = $form.find('.phone-form').val();
  }
  if ($form.find('.country-form').length > 0) {
    const userSelectedCountry = $form.find('.country-form').val();
    // If userselectedCountry is differ from ip based geoLocation data then remove ip based geoLocation data
    if (userSelectedCountry && userSelectedCountry !== freshmarketerContact['country']) {
      for (const removalItem of ['state', 'city', 'continent', 'zipcode']) {
        delete freshmarketerContact[removalItem];
      }
      freshmarketerContact['country'] = userSelectedCountry;
    }
  }

  const addCustomField = (element) => {
    try {
      const $element = $(element);
      let freshmarketerKey = $element.attr('data-freshmarketer-key');
      // Trim out spaces
      freshmarketerKey = 'cf_' + freshmarketerKey.replace(/\s+/gi, '');
      freshmarketerContact['custom_field'][freshmarketerKey] = $element.val();
    } catch (e) {
      SiteUtilities.log(
        'GenericForm - Freshmarketer Custom Field Error',
        'error',
        'FW.Submit.genericForm',
        2,
        e
      );
    }
  };
  // Handle Custom Dropdown fields.
  if ($form.find('.custom-dropdown-form').length > 0) {
    $form.find('.custom-dropdown-form').each((index, element) => {
      addCustomField(element);
    });
  }
  // Handle Custom Dropdown fields.
  if ($form.find('.custom-dropdown-form-referral').length > 0) {
    $form.find('.custom-dropdown-form-referral').each((index, element) => {
      addCustomField(element);
    });
  }
  // Custom textbox fields
  if ($form.find('.custom-textbox-form').length > 0) {
    $form.find('.custom-textbox-form').each((index, element) => {
      // Check is that field is conditional inputs or not.
      if ($(element).data('conditional-input-id') !== undefined && $(element).data('hidden') === true) return;
      addCustomField(element);
    });
  }
  // Custom textarea fields
  if ($form.find('.custom-textarea-form').length > 0) {
    $form.find('.custom-textarea-form').each((index, element) => {
      addCustomField(element);
    });
  }
  // Handle Timeslot fields
  if ($form.find('.time-slot-dropdown-form').length > 0) {
    $form.find('.time-slot-dropdown-form').each((index, element) => {
      addCustomField(element);
    });
  }
  // Custom checkbox field
  if ($form.find('.custom-checkbox').length > 0) {
    const $customCheckboxDiv = $form.find('.custom-checkbox');
    let freshmarketerKey = $customCheckboxDiv.attr('data-freshmarketer-key');
    freshmarketerKey = 'cf_' + freshmarketerKey.replace(/\s+/gi, '');
    const checkboxValues = getCheckboxValueString($customCheckboxDiv);
    freshmarketerContact['custom_field'][freshmarketerKey] = checkboxValues;
  }

  const subProduct = $form.data('sub_product') || null;
  if (subProduct) {
    freshmarketerContact.custom_field.cf_subproduct = subProduct;
  }

  if ($form.find('.department-form').val()) {
    freshmarketerContact.custom_field.cf_Department = $form.find('.department-form').val();
  }

  if ($form.find('.job-level-form').val()) {
    freshmarketerContact.custom_field.cf_JobLevel = $form.find('.job-level-form').val();
  }

  // Custom lead consent checkbox field
  const $customLeadConsentCheckbox = $form.find('.lead-consent-field');
  if ($customLeadConsentCheckbox.length > 0) {
    const checkboxValue = $customLeadConsentCheckbox.is(':checked');
    freshmarketerContact['custom_field']['cf_consentcheckbox'] = checkboxValue;
  }

  const freshmarketerData = {
    freshmarketerObject: freshmarketerContact
  };

  return freshmarketerData;
};

const addDemoFormFMPayload = (form, data) => {
  const $form = $(form);
  let selectedProd = null;
  const parseDemoFormType = (element) => {
    try {
      const $element = $(element);
      const backEndKey = $element.attr('data-backend-key').replace(/\s+/gi, '');
      if (backEndKey === 'demo-form-prod') {
        selectedProd = $element.val();
      }
    } catch (e) {
      SiteUtilities.log(
        'GenericForm - Parsing Form Data on Demo Form',
        'error',
        'FW.Submit.addDemoFormFMPayload',
        2,
        e
      );
    }
  };
  // Handle Custom Dropdown fields.
  if ($form.find('.custom-dropdown-form').length > 0) {
    $form.find('.custom-dropdown-form').each((index, element) => {
      parseDemoFormType(element);
    });
  }
  if (selectedProd) {
    const prodPayload = getPayload(selectedProd) || {};
    data['freshmarketerObject']['custom_field']['cf_recentnote'] = selectedProd;
    $form.data('fm_asset_id', prodPayload['assetId']);
    for (const fmKey in prodPayload['customFields']) {
      if (fmKey === 'cf_campaigndate') {
        const dateObject = new Date();
        const dateInfo = {
          dateD: dateObject.getDate(),
          monthM: dateObject.getMonth() + 1,
          yearYYYY: dateObject.getFullYear()
        };
        data['freshmarketerObject']['custom_field'][fmKey] = [dateInfo.yearYYYY, dateInfo.monthM, dateInfo.dateD].join('-');
      } else {
        data['freshmarketerObject']['custom_field'][fmKey] = prodPayload['customFields'][fmKey];
      }
    }
  }
};

const genericForm = (classname, form) => {
  const $form = $(form);
  const isGdprCheckboxVisible = $form.find('.eu-extra-info').is(':visible');
  const isGdprCheckboxMandatory = $form.attr('data-is-gdpr-checkbox-mandatory');
  const unsubscribe = !($form.find('input[name="send_promotions"]').is(':checked'));
  if (isGdprCheckboxVisible && isGdprCheckboxMandatory && unsubscribe) {
    const gdprMandatoryErrorMsg = $form.attr('data-gdpr-checkbox-mandatory-error');
    $form.find('.promotional-offers').append(`<div class="pt-xs"><em id="gdpr-error" class="error">${gdprMandatoryErrorMsg}</em></div>`);
    return;
  }
  const $body = $('body');
  $form.addClass('button--loading');
  const emailId = $form.find('.email-form').val();
  const $customDropdown = ($form.find('.custom-dropdown-form').length) ? $form.find('.custom-dropdown-form').val() : false;
  const emailHash = SiteUtilities.getShaHash(emailId);
  const tracking = $form.attr('data-tracking');
  const gatarget = $form.attr('data-gatarget');
  const geoLocation = LocationUtilities.getGeoLocation();
  const redirectToCalendly = $form.data('redirect-calendly');
  const pageUrls = $form.data('redirect-page-urls');
  const functionality = $form.attr('data-functionality') || 'feedback';
  const sendTransactionalEmail = $form.data('transactional-email') && (emailId && emailId.trim());
  const iframeRedirectFlag = $form.data('iframe-redirect');
  const emailQueryParamKey = $form.data('email-qparam');
  let emailQueryParam = '';
  if (emailQueryParamKey && emailQueryParamKey.length > 0) {
    emailQueryParam = `&${emailQueryParamKey}=${emailId}`;
  }

  if ($customDropdown && pageUrls) {
    const keyValues = pageUrls.split(',');
    const redirectUrls = {};
    keyValues.forEach((url) => {
      const splittedUrl = url.split('==');
      redirectUrls[splittedUrl[0]] = splittedUrl[1];
    });
    $form.data('open-url', redirectUrls[$customDropdown]);
  }

  const setUserDetailsToQueryString = () => {
    let openLink = $form.data('open-url');
    if (openLink) {
      const calendlyObj = {
        name: `${$form.find('.first-name-form').val()} ${$form.find('.last-name-form').val()}`,
        calendlyuser: emailId && emailId.split('@')[0],
        calendlydomain: emailId && emailId.split('@')[1],
        a1: $form.find('.custom-textbox-form').val()
      };
      for (const k in calendlyObj) {
        if (calendlyObj[k]) {
          openLink = `${openLink}${openLink.includes('?') ? '&' : '?'}${k}=${calendlyObj[k]}`;
        }
      }
      $form.data('open-url', openLink);
    }
  };

  // Applicable for form functionality = Redirect to other page
  const redirect = () => {
    if ($form.data('open-url')) {
      // close the modal if present on successful submission and then redirect
      $form.parents('.modal.in').trigger('click');
      const openLink = $form.data('open-url');
      const ehashParam = openLink.match(/\?./) ? `&ehash=${emailHash}` : `?ehash=${emailHash}`;
      if (isNewTab === true) {
        $form.removeClass('button--loading');
        $form.find('.button').removeClass('button--loading').removeAttr('disabled', 'disabled');
        window.open(openLink + ehashParam + emailQueryParam);
      } else {
        if (iframeRedirectFlag === 'yes') {
          window.parent.location.href = openLink + ehashParam + emailQueryParam;
        } else {
          window.location.href = openLink + ehashParam + emailQueryParam;
        }
      }
    }
  };

  // Construct Freshmarketer/Freshsales Object based on tracking.

  const executeConfiguredfunctionality = () => {
    // If functionality is feedback. Pass the function to animateFormWrapper.

    if (functionality === 'feedback') {
      // Not using animateFormWrapper intentionally as there are issues with animateFormWrapper (Its not too reusable as of today. Hardcoded post to GA etc).
      setTimeout(function () {
        const $formWrapper = $form.parents('.form-wrapper');
        const $thankYouCard = $formWrapper.siblings('.thank-you-card');
        $form.addClass('active');
        $form.siblings('[data-form-heading]').addClass('hide');
        $thankYouCard.addClass('active').css({ height: 'auto' });
        const thankYouCardHeight = $formWrapper.siblings('.thank-you-card.active').innerHeight();
        $formWrapper.animate({
          height: thankYouCardHeight
        });
      }, 1000);
    }

    if (functionality === 'gated_video') {
      // Show gated video in section banner cta.
      const sectionTargetID = `#${$form.attr('data-target')}`;
      const $section = $(sectionTargetID);
      // Set local storage item so that modal button is not visible again.
      const localStorageKey = $section.find('[data-local-storage-key]').attr('data-local-storage-key');
      localStorage.setItem(localStorageKey, true);
      setTimeout(() => {
        $('.modal.in').trigger('click');
        const videoID = $section.find('[data-video-popup-target]').attr('data-video-popup-target');
        const $popupElement = $('#video-popup-' + (window.wistiaVideoID || videoID));
        $popupElement.addClass('video-popup-active');
        $('body').addClass('overflow-hidden');
        $popupElement.fadeIn(300);
      }, 300);
    }

    // Functionality for navigating to some other url.
    if (functionality === 'navigate_url') {
      if (redirectToCalendly) {
        setUserDetailsToQueryString();
      }
      // We need to wait for a few events before we redirect an user to another page. For eg if only freshsales was selected do the redirect right away once freshsales post is complete.Otherwise return a deferred object for some other function to consume.

      // If tracking is just virtual_hit_ga redirect after 1000 ms.
      if (tracking === 'virtual_hit_ga') {
        setTimeout(() => {
          redirect();
        }, 1000);
      }
      const deferredArray = [];
      // Get the number of items to track. eg: 3 if we want to post to ap, freshsales, freshmarketer. Make sure we discard virtual_hit_ga as we dont't create a deferred object for that.
      let trackingCount = tracking.replace(/,?virtual_hit_ga/, '').split(',').length;
      // For Cases where Autopilot tracking info is already stored in the DB.
      if (tracking.includes('autopilot') || tracking.includes('multi_prod_demo_form') || tracking.includes('tray_api') || tracking.includes('fsales_solution_partner')) {
        trackingCount--;
      }

      const fmEventType = sendTransactionalEmail ? 'transactionalEmailCompleted' : 'freshmarketerPostCompleted';
      $body.on(fmEventType, () => {
        const $freshmarketerDeferred = $.Deferred();
        $freshmarketerDeferred.resolve();
        deferredArray.push($freshmarketerDeferred);
      });
      // At this point there are multiple tracking events that need to happen before we redirect.
      const redirectInterval = setInterval(() => {
        // Redirect if deferredArray.length equals trackingCount.
        if (deferredArray.length === trackingCount) {
          clearInterval(redirectInterval);
          redirect();
        }
      }, 100);
    }
  };
  if (tracking.includes('freshmarketer')) {
    const data = buildFreshmarketerObject(form, geoLocation);
    if (tracking.includes('multi_prod_demo_form')) {
      addDemoFormFMPayload(form, data);
    }
    SiteUtilities.freshmarketerPost(data, true, form);
    if (sendTransactionalEmail) {
      $body.on('freshmarketerPostCompleted', () => {
        SiteUtilities.sendTransactionalEmail(form, data, functionality === 'navigate_url');
      });
    }
  }
  // Functionality to post data to Tray web hooks
  if (tracking.includes('tray_api')) {
    postWebinarDetailsToTray(form);
  }
  if (tracking.includes('fdesk_ticket')) {
    createFdeskSupportTicket(form);
  }
  // Functionality to post data to solution partner
  if (tracking.includes('fsales_solution_partner')) {
    postToFsalesSolutionPartner(form).then(function () {
      executeConfiguredfunctionality();
    });
  }
  if (tracking.includes('virtual_hit_ga')) {
    try {
      var trackers = ga.getAll();
      for (var t = 0; t < trackers.length; t++) {
        var trackerName = trackers[t].get('name');
        ga(trackerName + '.set', {
          page: gatarget || window.location.href + `/complete?ehash=${emailHash}`,
          title: 'Registration Complete'
        });
        ga(trackerName + '.send', 'pageview', {
          page: gatarget || window.location.href + `/complete?ehash=${emailHash}`,
          title: 'Registration Complete'
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  // Create Lighthouse ticket request
  if (tracking.includes('lighthouse_ticket')) {
    const selectOption = $form.attr('data-lh-ticket-subject');
    if (selectOption === 'lh_ccpa_request') {
      ccpaRequest(form);
    }
  }

  const isNewTab = $form.data('is-new-tab');
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  if (!tracking.includes('fsales_solution_partner')) executeConfiguredfunctionality();
};

const waitlistForm = function (classname, form) {
  animateFormWrapper(classname);
};

const forrestFormHandler = (className, form) => {
  let forresterDirectUrl = window.location.search;
  if (forresterDirectUrl && forresterDirectUrl.includes('?forrester_direct_url=')) {
    forresterDirectUrl = decodeURIComponent(forresterDirectUrl.replace('?forrester_direct_url=', ''));
  } else {
    forresterDirectUrl = '#';
  }
  const firstName = $(form).find('.first-name-form').val();
  const lastName = $(form).find('.last-name-form').val();
  const emailid = $(form).find('.email-form').val();
  const phone = $(form).find('.phone-form').val();
  const company = $(form).find('input[name^="company"]').val() || '';
  const country = $(form).find('input[name^="country"]').val() || '';
  const designation = $(form).find('input[name^="designation"]').val() || '';
  const fmListId = $(form).find('.fm-list-id').val();
  const $sendPromotions = $('[name="send_promotions"]');
  // Freshmarketer Data
  if (fmListId) {
    const freshmarketerData = {
      freshmarketerObject: {
        first_name: firstName,
        last_name: lastName,
        email: emailid,
        company: company,
        country: country,
        designation: designation,
        phone: phone || '',
        contactable: $sendPromotions.length ? $sendPromotions.is(':checked') : true,
        custom_field: {
          cf_freshmarketer_list: fmListId,
          cf_recentnote: forresterDirectUrl || null,
          cf_title: designation
        }
      }
    };
    jQuery.when(
      SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
    ).then(function () {
      window.top.location.href = 'https://tools.totaleconomicimpact.com/go/freshworks/freshservice/index.html?reg=1';
    });
  } else {
    window.top.location.href = 'https://tools.totaleconomicimpact.com/go/freshworks/freshservice/index.html?reg=1';
  }
};

const wheelSpinnerForm = (className, form) => {
  const modalId = $(form).data('modalid');
  const uId = $(form).data('uid');
  $(modalId).modal('hide');
  const $wheelSpinner = $(`#wheel-wrapper-${uId}`);
  const spinnerLabels = $wheelSpinner.find('.spinner-labels').val().split(',');
  const spinnerButtonText = $wheelSpinner.find('.spinner-button-text').val() || 'Spin';
  const options = [];
  const colors = ['#FACE68', '#A82424'];
  const fontColors = ['#000000', '#FFFFFF'];
  $.each(spinnerLabels, function (index, item) {
    const obj = {};
    obj.text = item;
    obj.color = (colors[index % 2]);
    obj.fontSize = 16;
    obj.fontColor = (fontColors[index % 2]);
    options.push(obj);
  });

  // eslint-disable-next-line no-undef
  const wheel = new Wheel({
    el: document.getElementById(`wheel-${uId}`),
    data: options,
    radius: 280,
    buttonWidth: 75,
    buttonText: spinnerButtonText,
    color: {
      button: '#FFFFFF',
      buttonFont: '#4D4D4D',
      border: 'transparent'
    },
    onSuccess (data) {
      const firstName = $(form).find('.first-name-form').val();
      const lastName = $(form).find('.last-name-form').val();
      const emailid = $(form).find('.email-form').val();
      const phone = $(form).find('.phone-form').val();
      const company = $(form).find('input[name^="company"]').val() || '';
      const designation = $(form).find('input[name^="designation"]').val() || '';
      const fmListId = $(form).find('.fm-list-id').val();
      const $sendPromotions = $('[name="send_promotions"]');
      // Freshmarketer Data
      if (fmListId) {
        const freshmarketerData = {
          freshmarketerObject: {
            first_name: firstName,
            last_name: lastName,
            email: emailid,
            company: company,
            phone: phone || '',
            designation: designation,
            contactable: $sendPromotions.length ? $sendPromotions.is(':checked') : true,
            custom_field: {
              cf_freshmarketer_list: fmListId,
              cf_cftextbox: data.text,
              cf_RecentNote: 'Spin wheel CNY'
            }
          }
        };
        jQuery.when(
          SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
        ).then(function () {
          const thankyouContent = $(`#modal-spinner-thankyou-${uId}`).find('.spinner-thankyou-content').html().replace('&lt;&lt;&gt;&gt;', data.text);
          $(`#modal-spinner-thankyou-${uId}`).find('.spinner-thankyou-content').html(thankyouContent);
          $(`#modal-spinner-thankyou-${uId}`).modal('show');
        });
      }
    }
  });
  setTimeout(() => {
    wheel._run();
  }, 500);
};

const ccpaRequest = (form) => {
  // prepare payload
  const $form = $(form);
  const firstName = $form.find('.first-name-form').val() || '';
  const lastName = $form.find('.last-name-form').val() || '';
  const email = $form.find('.email-form').val() || '';
  const requestInformation = $form.find('.custom-textarea-form').val();

  const data = {
    payload: {
      quantity: 1,
      email: email,
      custom_fields: {
        first_name: firstName,
        last_name: lastName,
        email: email,
        request_for_information_about_deletion_of: requestInformation
      }
    },
    catalog_id: 1713 // CCPA Request catalogue ID
  };
  createLightHouseTicket(data);
};

const createLightHouseTicket = (data) => {
  // create request with payload
  try {
    jQuery.ajax({
      data: JSON.stringify(data),
      method: 'POST',
      url: 'https://alfred.freshworks.com/v1/create-fs-ticket',
      contentType: 'application/json',
      dataType: 'json'
    });
  } catch (e) {
    SiteUtilities.log(
      'SiteUtilites - Error: Failed to create lighthouse ticket',
      'error',
      'FW.SiteUtilites.createLightHouseTicket',
      2,
      e
    );
  }
};

const createFdeskSupportTicket = (form) => {
  const $form = $(form);
  const firstName = $form.find('.first-name-form').val() || '';
  const lastName = $form.find('.last-name-form').val() || '';
  const email = $form.find('.email-form').val() || '';
  const phone = $form.find('.phone-form').val() || '';
  const company = $form.find('.company-form').val() || '';
  const country = $form.find('.country-form').val() || '';
  const $customDropdown = $form.find('.custom-dropdown-form');
  const $customTextbox = $form.find('.custom-textbox-form');
  const $customTextArea = $form.find('.custom-textarea-form');
  const protocolRegex = /http:\/\/|https:\/\//gi;
  const languageCodes = ['de', 'nl', 'fr', 'se', 'es', 'latam', 'br', 'ru', 'jp', 'ko', 'it', 'cn', 'th', 'vi', 'pl', 'hk', 'fi', 'dk', 'no', 'tr', 'en-ae', 'en-za', 'eu', 'ms', 'id'];
  let pageUrl = SiteUtilities.getCurrentLocation();
  pageUrl = pageUrl.replace(protocolRegex, '');
  const tags = (pageUrl.split('/')[1] && languageCodes.includes(pageUrl.split('/')[1])) ? [`${pageUrl.split('/')[1]}-${pageUrl.split('/')[2] ? pageUrl.split('/')[2] : ''}`] : [pageUrl.split('/')[1]];
  const description = {
    'E-mail': email,
    Company: company,
    Country: country
  };
  // In default product id set to freshworks (23498)
  const productId = Number($form.data('product-id')) || 23498;
  // In default group id set to presales (106108)
  const groupId = Number($form.data('group-id')) || 106108;
  const subject = $form.data('fdesk-ticket-subject') || '';

  if ($customDropdown.length > 0 || $customTextbox.length > 0 || $customTextArea.length > 0) {
    let $customFields = $.merge($customDropdown, $customTextbox);
    $customFields = $.merge($customFields, $customTextArea);
    $customFields.each((index, element) => {
      // Check is that field is conditional inputs or not.
      if ($(element).data('conditional-input-id') !== undefined && $(element).data('hidden') === true) return;
      description[$(element).data('backend-key')] = String($(element).val()).trim();
    });
  }

  const formatDescription = (description) => {
    let formatedDescription = '<p>';
    for (const key in description) {
      formatedDescription += `${key}: ${description[key]} <br>`;
    }
    formatedDescription += '</p>';
    return formatedDescription;
  };

  const createTicketOptions = {
    name: `${firstName} ${lastName}`.trim(),
    email: email,
    phone: phone,
    subject,
    tags,
    group_id: groupId,
    description: formatDescription(description),
    product_id: productId
  };

  try {
    jQuery.ajax({
      data: JSON.stringify(createTicketOptions),
      method: 'POST',
      url: 'https://alfred.freshworks.com/v1/fd-create-ticket',
      contentType: 'application/json',
      dataType: 'json'
    });
  } catch (e) {
    SiteUtilities.log(
      'SiteUtilites - Error: Failed to create freshdesk ticket',
      'error',
      'FW.SiteUtilites.createFdeskSupportTicket',
      2,
      e
    );
  }
};

const postWebinarDetailsToTray = (form) => {
  const $form = $(form);
  const $freshmarketerCustomInputs = $form.find('.custom-inputs.type-freshmarketer');
  const freshmarketerObj = { freshmarketerObject: { custom_field: {} } };
  const occurrenceId = $form.find('.time-slot-dropdown-form').find(':selected').attr('data-occurrence-id') || '';
  const webinarId = $form.find('.time-slot-dropdown-form').find(':selected').attr('data-webinar-id') || '';
  const demoAssetId = $form.find('.time-slot-dropdown-form').find(':selected').attr('data-asset-id') || '';
  const geoLocation = LocationUtilities.getGeoLocation();
  const customKeys = {
    cf_region: 'region',
    cf_source: 'source',
    cf_product: 'product',
    cf_marketingcampaign: 'marketing_campaign',
    cf_subproduct: 'sub_product',
    cf_campaigndate: 'campaign_date',
    cf_recentnote: 'recent_note'
  };
  const trayPayload = {
    event: 'webinar.registration',
    id: webinarId || $form.attr('data-webinar-id') || '',
    payload: {
      first_name: $form.find('.first-name-form').val() || '',
      last_name: $form.find('.last-name-form').val() || '',
      email: $form.find('.email-form').val() || '',
      company: $form.find('.company-form').val() || '',
      asset_id: $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313,
      tactic_id: SiteUtilities.getTacticID(),
      comments: 'Sent from Tray LinkedIn to FM WF',
      page_url: window.location.href || '',
      occurrence_ids: [occurrenceId],
      demo_asset_id: demoAssetId || $form.attr('data-tray-asset-id') || '',
      country: geoLocation ? geoLocation.countryName : ''
    }
  };
  if ($freshmarketerCustomInputs.length > 0) {
    SiteUtilities.customHiddenFormFields($freshmarketerCustomInputs, freshmarketerObj);
  }
  for (const key in freshmarketerObj['freshmarketerObject']['custom_field']) {
    const lowercaseKey = key.toLowerCase();
    if (customKeys[lowercaseKey]) {
      trayPayload['payload'][customKeys[lowercaseKey]] = freshmarketerObj['freshmarketerObject']['custom_field'][key];
    }
  }
  try {
    jQuery.ajax({
      data: JSON.stringify(trayPayload),
      method: 'POST',
      url: 'https://alfred.freshworks.com/v1/tray-post',
      contentType: 'application/json',
      dataType: 'json'
    });
  } catch (e) {
    SiteUtilities.log(
      'SiteUtilites - Error: Failed to post to Tray',
      'error',
      'FW.SiteUtilites.postWebinarDetailsToTray',
      2,
      e
    );
  }
};

const postToFsalesSolutionPartner = (form) => {
  const $form = $(form);
  const firstName = $form.find('.first-name-form').val() || '';
  const lastName = $form.find('.last-name-form').val() || '';
  const company = $form.find('.company-form').val() || '';
  const email = $form.find('.email-form').val() || '';
  const phone = $form.find('.phone-form').val() || '';
  const country = $form.find('.country-form').val() || '';
  const partnerType = $form.attr('data-fsales-partner-type') || '';
  const newFsalesLead = {
    contact: {
      first_name: firstName,
      last_name: lastName,
      emails: email,
      country: country,
      lead_source_id: '4000323648',
      custom_field: {
        cf_desired_partner_type_lead_field: partnerType,
        cf_signup_referrer: window.location.href || '',
        cf_mailing_country: country,
        cf_company: company,
        cf_phone_no: phone
      }
    }
  };
  const deferrer = $.Deferred();
  $form.find('.custom-dropdown-form').each(function () {
    if (this.getAttribute('data-backend-key') && this.value) {
      newFsalesLead['contact']['custom_field'][this.getAttribute('data-backend-key')] = this.value;
    }
  });
  SiteUtilities.freshsalesPostV2(newFsalesLead, false).then(function (response) {
    if (response.statusCode === 400 && response.message === 'This email is already exists') {
      $('.email-form').parent('.form-field').addClass('error').find('.error-wrapper').html(`<em id="email-error" class="error">This email is already exists</em>`);
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      $form.removeClass('button--loading');
      deferrer.reject();
    } else {
      $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
      deferrer.resolve();
    }
  });
  return deferrer;
};

export default {
  animateFormWrapper,
  contactForm,
  roiForm,
  roiDetailedReportForm,
  webinarSubscribeForm,
  unsubscribe,
  emailOnlySubscription,
  gdprSubscriptionToggleForm,
  whitepaperForm,
  jobDescriptionForm,
  partnerResellerSignupForm,
  createSupportTicket,
  affiliateForm,
  expressCheckoutForm,
  academyForm,
  accessSecurityResourcesForm,
  bugReportForm,
  genericForm,
  sysadminForm,
  waitlistForm,
  forrestFormHandler,
  wheelSpinnerForm,
  createFdeskSupportTicket
};
